import { TooltipProvider } from '@antimatterhq/ui/components/tooltip';
import { ColorModeProvider } from '@antimatterhq/ui/contexts/ColorModeContext';
import { JotaiDevToolsProvider } from './jotai-dev-tools';
import { AppRouterProvider } from '@/providers/router';
import { TanStackQueryClientProvider } from '@/providers/query';
import { WorkspaceProvider } from '@/contexts/WorkspaceContext';
import { WarehouseLocationProvider } from '@/contexts/WarehouseLocationContext';
import AuthHandler from '@/components/auth/AuthHandler';
import { InstanceIdProvider } from '@/contexts/InstanceIdContext';
import RedirectHandler from '@/components/auth/RedirectHandler';
import { ClientRequestHandlersProvider } from '@/providers/request-handlers';
import FeatureFlagProvider from '@/contexts/FeatureFlagContext';
import { FrameStateProvider } from '@/providers/frame-state';
import { WindowEnvironmentProvider } from '@/providers/window-environment';
import 'jotai-devtools/styles.css';

export const Providers = ({ children }: { children?: React.ReactNode }) => {
  return (
    <FrameStateProvider>
      <ColorModeProvider>
        <InstanceIdProvider>
          <FeatureFlagProvider>
            <WindowEnvironmentProvider>
              <TanStackQueryClientProvider>
                <ClientRequestHandlersProvider>
                  <WorkspaceProvider>
                    <WarehouseLocationProvider>
                      <TooltipProvider>
                        <RedirectHandler>
                          <AuthHandler>
                            <AppRouterProvider />
                          </AuthHandler>
                        </RedirectHandler>
                        {children}
                        <JotaiDevToolsProvider />
                      </TooltipProvider>
                    </WarehouseLocationProvider>
                  </WorkspaceProvider>
                </ClientRequestHandlersProvider>
              </TanStackQueryClientProvider>
            </WindowEnvironmentProvider>
          </FeatureFlagProvider>
        </InstanceIdProvider>
      </ColorModeProvider>
    </FrameStateProvider>
  );
};
